import { useQuery } from 'react-query';
import { dsoCartService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useRetriveDsoCart = () => {
  return useQuery(
    `${ServerStateKeysEnum.dsoCart}`,
    () => {
      return dsoCartService.getCartDetails();
    },
    {
      staleTime: Infinity,
    }
  );
};
